<template>
  <div class="app-container">
    <el-form label-position="top">
      <el-row :gutter="20">
        <el-col :span="6">
          <!-- 班次编号 -->
          <el-form-item :label="$t('routes.班次编号')">
            <ScheduleNumberSelect v-model="queryForm.params.scheduleNumber" :list="scheduleNumberList" is-all />
          </el-form-item>

          <!--          <el-form-item :label="$t('routes.班次编号')">-->
          <!--            <el-input v-model="queryForm.params.scheduleNumber" clearable :placeholder="$t('GlobalSetObj.pleaseInput')" />-->
          <!--          </el-form-item>-->
        </el-col>
        <el-col :span="6">
          <div style="margin-top: 30px">
            <el-button
              type="primary" size="small" icon="el-icon-search"
              @click="asyncGetList"
            >{{ $t('operationCenter.Procurar') }}</el-button>
            <el-button size="small" icon="el-icon-refresh-left" @click="reset">{{ $t('GlobalSetObj.reset') }}</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <el-card class="box-card table-height" :style="{height: `${tableHeightRow.height}px`}">
      <el-button
        type="primary" size="small" style="margin-bottom: 10px"
        icon="el-icon-plus"
        @click="open"
      >{{ $t('routes.新增班次') }}</el-button>
      <el-table
        border
        :data="tableData"
        :header-cell-style="{background:'#f2f2f2',color:'black'}"
      >
        <!--        :span-method="arraySpanMethod"-->
        <el-table-column
          :label="$t('GlobalSetObj.serial')" type="index" width="70"
          align="center"
        />
        <!--班次编号-->
        <el-table-column
          :label="$t('routes.班次编号')" min-width="120" prop="scheduleNumber"
          align="center"
        />
        <!--客户-->
        <el-table-column
          :label="$t('GlobalSetObj.client')" min-width="120" prop="customerNameList"
          align="center"
        />
        <!--到达转运中心-->
        <el-table-column
          :label="$t('collectionCenter.ArrivalAtTransferCenter')" min-width="120" prop="transferCenterName"
          align="center"
        />
        <!--揽收时间-->
        <el-table-column
          :label="$t('collectionCenter.lanshouT')"
          min-width="120"
          align="center"
          prop="collectTime"
          class-name="collectTimeList"
        >
          <template slot-scope="scope">
            <div
              v-for="(item, index) in scope.row.collectTimeList"
              :key="index"
              :style="{'border-bottom': index < scope.row.collectTimeList.length - 1 ? '1px solid #ebeef5' : ''}"
              style="padding: 5px 10px"
            >
              {{ item.collectTime[0] }} ~ {{ item.collectTime[1] }}
            </div>
          </template>
        </el-table-column>
        <!--揽收装车时间-->
        <el-table-column
          :label="$t('GlobalSetObj.collectuploadTime')" min-width="120" prop="collectTimeList"
          align="center"
          class-name="collectTimeList"
        >
          <template slot-scope="scope">
            <div
              v-for="(item, index) in scope.row.collectTimeList"
              :key="index"
              :style="{'border-bottom': index < scope.row.collectTimeList.length - 1 ? '1px solid #ebeef5' : ''}"
              style="padding: 5px 10px"
            >
              {{ item.collectLoadFinishTime }}
            </div>
          </template>
        </el-table-column>
        <!--到达转运中心时间-->
        <el-table-column
          :label="$t('collectionCenter.ArrivalTimeAtTransferCenter')" min-width="120" prop="hub1ArrivalTime"
          align="center"
          class-name="collectTimeList"
        >
          <template slot-scope="scope">
            <div
              v-for="(item, index) in scope.row.collectTimeList"
              :key="index"
              :style="{'border-bottom': index < scope.row.collectTimeList.length - 1 ? '1px solid #ebeef5' : ''}"
              style="padding: 5px 10px"
            >
              {{ item.hub1ArrivalTime }}
            </div>
          </template>
        </el-table-column>
        <!--操作-->
        <el-table-column :label="$t('collectionCenter.operation')" width="120" align="center">
          <template slot-scope="scope">
            <el-tooltip
              :content="$t('CenterForSorting.edit')"
              class="item"
              effect="dark"
              placement="top"
            >
              <el-button size="mini" type="text" @click="edit(scope.row)">
                <i
                  class="el-icon-edit-outline hoverClass"
                  style="font-size: 22px; color: #00A551"
                /><!-- 编辑 -->
              </el-button>
            </el-tooltip>
            <el-tooltip
              :content="$t('GlobalSetObj.Delete')"
              class="item"
              effect="dark"
              placement="top"
            >
              <el-popconfirm
                :title="$t('GlobalSetObj.AreYouSureDelete')"
                @confirm="deleteClass(scope.row)"
              >
                <el-button
                  slot="reference" size="mini" style="margin: 0 10px"
                  type="text"
                >
                  <i
                    class="el-icon-delete hoverClass"
                    style="font-size: 22px; color: #f56c6c"
                  /><!-- 清除格口数据 -->
                </el-button>
              </el-popconfirm>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page="queryForm.pageNumber"
          :page-size="queryForm.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0;float: right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>
    <!--新增班次-->
    <el-dialog
      :title="addRow.title"
      :visible.sync="addRow.isBool"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      top="5vh"
      width="80%"
    >
      <AddCmp
        :key="addRow.isBool"
        :index="addRow.index"
        :row="addRow"
        :transfer-list="transferList"
        @close="onClose"
      />
    </el-dialog>
  </div>
</template>

<script>
// import ListItemCmp from './cmp/ListItemCmp.vue';
import {
  apiDepartureScheduleList,
  apiDepartureScheduleGetScheduleNumber,
  apiDepartureScheduleDelete
} from '@/api/routerPlan.js';
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight.js';
import { DIALOG_TEXT, SCHEDULE_ROW } from './utils';
import { cloneDeep } from 'lodash-es';
import ScheduleNumberSelect from '@/views/route/dryBranchFlowManagement/cmp/ScheduleNumberSelect.vue';
import { routes } from '@/lang/type/newRoutes';
import { getSiteTransfer } from '@/api/orderApi';

const PARAMS = {
  scheduleNumber: '' // 班次编号
};

export default {
  name: '',

  components: {
    ScheduleNumberSelect,
    // ListItemCmp,
    AddCmp: () => import('./cmp/AddCmp.vue')
  },

  mixins: [estimateTableHeight],

  data() {
    return {
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          ...PARAMS
        }
      },
      total: 0,
      tableData: [],
      scheduleNumberList: [], // 班次编号
      customerList: [], // 客户列表
      transferList: [], // 转运中心列表
      addRow: {
        index: 0,
        isBool: false,
        title: DIALOG_TEXT.add,
        customerIdList: [],
        row: {
          ...cloneDeep(SCHEDULE_ROW)
          // id: 0,
          // scheduleNumber: '', // 班次编号
          // collectTimeList: [] // 揽收时间
        }
      }
    };
  },
  computed: {
    routes() {
      return routes;
    }
  },

  created() {
    this.asyncGetList();
    this.asyncApiDepartureScheduleGetScheduleNumber();
    // this.asyncCustomerList();
    this.getstateTransfer();
  },

  methods: {
    // 获取当前用户的转运中心所属州和转运中心
    getstateTransfer() {
      getSiteTransfer().then((res) => {
        if (res.code === 200) {
          this.transferList = res.data;
        }
      });
    },
    // 删除班次
    deleteClass(row) {
      apiDepartureScheduleDelete(row.id).then(res => {
        if (res.code !== 200) { return; }
        this.asyncGetList();
      });
    },
    // 获取所有班次
    asyncApiDepartureScheduleGetScheduleNumber() {
      apiDepartureScheduleGetScheduleNumber().then(res => {
        console.log(res);
        this.scheduleNumberList = Object.freeze(res.data.map(item => {
          return {
            label: item,
            value: item
          };
        }));
      }).catch(err => {
        console.error(err);
      });
    },

    // 重置
    reset() {
      this.queryForm.pageNumber = 1;

      this.queryForm.params = {
        ...PARAMS
      };

      this.asyncGetList();
    },

    // 点击分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.asyncGetList();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.asyncGetList();
    },
    // 班次列表查询
    asyncGetList() {
      apiDepartureScheduleList(this.queryForm).then(res => {
        // console.log(res);

        const { total, records } = res.data;
        this.total = total;
        const arr = (records || []).map(item => {
          const {
            id,
            scheduleNumber,
            transferCenterName,
            transferCenterId,
            collectTimeList,
            customerIdList,
            customerNameList
          } = item;
          const obj = {
            id,
            scheduleNumber,
            transferCenterId,
            customerIdList,
            transferCenterName,
            customerNameList,
            collectTimeList: []
          };

          obj.collectTimeList = (collectTimeList || []).map(key => {
            const { collectLoadFinishTime, collectTime, hub1ArrivalTime } = key;
            const arr = collectTime.split('-');
            return {
              collectLoadFinishTime, // 揽收装车完成时间
              collectTime: arr, // 揽收时间
              hub1ArrivalTime // HUB1到件时间
            };
          });
          return obj;
        });
        this.tableData = Object.freeze(arr);
      }).catch(err => {
        console.error(err);
      });
    },

    // 添加
    open() {
      this.addRow.index += 1;
      this.addRow.title = DIALOG_TEXT.add;
      this.addRow.row.id = null;
      this.addRow.row.scheduleNumber = '';
      this.addRow.row.collectTimeList = [];
      this.addRow.row.customerIdList = [];

      this.addRow.isBool = true;
    },
    // 修改
    edit(row) {
      const { id, scheduleNumber, collectTimeList, customerIdList, customerNameList, transferCenterId } = row;
      this.addRow.index += 1;
      this.addRow.title = DIALOG_TEXT.edit;
      this.addRow.scheduleNumber = scheduleNumber;
      this.addRow.transferCenterId = transferCenterId;
      this.addRow.customerIdList = customerIdList;
      this.addRow.customerNameList = customerNameList;
      this.addRow.row.id = id;
      this.addRow.row.collectTimeList = collectTimeList.map(item => {
        const { collectLoadFinishTime, hub1ArrivalTime, collectTime } = item;
        return {
          collectTime,
          collectLoadFinishTime,
          hub1ArrivalTime
        };
      });

      this.addRow.isBool = true;
    },

    onClose(isBool) {
      this.addRow.isBool = false;
      if (isBool) {
        this.queryForm.pageNumber = 1;
        this.asyncGetList();
        this.asyncApiDepartureScheduleGetScheduleNumber();
      }
    }
  }

};
</script>

<style scoped>
.box-card {
   overflow-y: auto;
}
</style>
<style>
.table-height .collectTimeList {
  padding: 0;
}
.table-height .collectTimeList .cell {
  padding-left: 0;
  padding-right: 0;
}
</style>
